import common from '../common'

export default {
    list(params) {
        return common.get('/rocheManage/external/externalAdDepart/list',params);
    },

    add(params) {
        return common.post('/rocheManage/external/externalAdDepart/add',params);
    },

    edit(params) {
        return common.put('/rocheManage/external/externalAdDepart/edit',params);
    },

    delete(params) {
        return common.delete('/rocheManage/external/externalAdDepart/delete',params);
    },

    deleteBatch(params) {
        return common.delete('/rocheManage/external/externalAdDepart/deleteBatch',params);
    },

    exportXls(params) {
      return common.get('/rocheManage/sys/user/exportXls', params, {responseType: 'blob'});
    },
  
    getEdcByAd(params) {
      return common.get('/rocheManage/bus/busBudgetDetail/getEdcByAd',params);
    },
  
    getAllowDeparts() {
        return common.get('/rocheManage/external/externalDepart/list',{pageSize:999999, pageNo:1});
    },
}



// WEBPACK FOOTER //
// ./src/api/sysmanagement/externalprivilege.js